import {Component, Input, OnChanges, OnInit, SimpleChanges,} from "@angular/core";
import {IntraDoHistorique, IntraDoOperation, IntraDoSinistreApi} from "../../../../../../shared/sdk";
import {
  DismissModaleDirective
} from '../../../../../../core/directives/custom/buttons/dismissModale/dismissModale.directive';
import {NgbActiveModal} from '../../../../../../core/components/ngBootstrap/modal/modal-ref';
import {TranslocoPipe} from '@jsverse/transloco';
import {AppDownloadService} from '../../../../../../core/services/app.download.service';
import {
  TableHistoriqueSinistrePartial
} from '../../../partials/tableHistoriqueSinistre/table.historique.sinistre.partial';
import {forkJoin} from 'rxjs';
import { DestroyableComponent } from "../../../../../../core/classes/destroyable.component";

@Component({
  selector: 'SeeHistoriqueSinistreModaleDirective',
  standalone: true,
  templateUrl: './seeHistoriqueSinistreModale.directive.html',
  imports: [
    DismissModaleDirective,
    TranslocoPipe,
    TableHistoriqueSinistrePartial
  ],
  providers: [
    AppDownloadService
  ]
})
export class SeeHistoriqueSinistreModaleDirective extends DestroyableComponent implements OnInit, OnChanges{

  @Input() sinistreId: number = null;
  @Input() nbHistoriques: number | null = null;
  @Input() operation!: IntraDoOperation;

  protected historiques: IntraDoHistorique[] = [];

  constructor(
    public doSinistreApiService: IntraDoSinistreApi,
    public activeModal: NgbActiveModal,
  ) {
    super();

  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['sinistreId'].currentValue){
      this.load()
    }
  }

  load(){
    if(this.sinistreId){

      let filter = {order: 'date DESC'};
      if(this.nbHistoriques){
        filter['where'] = {limit: this.nbHistoriques};
      }

      let fork = [
        this.doSinistreApiService.getHistoriques(this.sinistreId, filter),
        this.doSinistreApiService.getOperation(this.sinistreId)
      ]
      this.subscribe(forkJoin(fork), (res: [IntraDoHistorique[], IntraDoOperation]) => {
        this.historiques = res[0];
        this.operation = res[1];
      })
    }
  }

  ngOnInit() {
    if(this.sinistreId){
      this.load()
    }
  }

}
